import { create } from "zustand";

const useSearchStore = create((set) => ({
  searchModalVisible: false,
  showSearch: () => set(() => ({ searchModalVisible: true })),
  hideSearch: () => set(() => ({ searchModalVisible: false })),
}));

export default useSearchStore;
